import { observable, action } from 'mobx';

import {message} from 'antd';
import {BaseStore} from './base';
import * as api from  '../helpers/api';
import {handleRequestError} from '../helpers/errors';
import {getUser, onUserChange, setUser} from '../helpers/session';
import {addCar} from '../helpers/api';
import {removeCars} from '../helpers/api';
import {fcheck} from '../helpers/api';
import {addRequestCar} from '../helpers/api';
import {removeRequestCars} from '../helpers/api';
import {fcheckRequestCar} from '../helpers/api';
import {moveCars} from '../helpers/api';
import {exportCars} from '../helpers/api';
import { save } from 'save-file'
import {reorderClient} from '../helpers/api';
import {addArchiveCar} from '../helpers/api';
import {removeArchiveCars} from '../helpers/api';
import {fcheckArchiveCar} from '../helpers/api';
import {setSendSms} from '../helpers/api';
import {orderUpClients} from '../helpers/api';
import {userCarsAdd} from '../helpers/api';
import {userCarsRemove} from '../helpers/api';
import {userCarsCheck} from '../helpers/api';
import {userCarsExport} from '../helpers/api';
import {userCarsReorder} from '../helpers/api';
import {userCarsOrderUp} from '../helpers/api';
import {Env} from '../env';

export class UserCarsStore extends BaseStore {
  @observable items = null;
  @observable isLoadingClients = false;

  @action async loadAll(force = false) {
    if(!force && (this.items)) {
      return ;
    }

    console.log('loadAll');

    this.isLoadingClients = true;
    const res = await api.userCarsGet();
    if(res) {
      this.items = res;
    }

    this.isLoadingClients = false;
  }

  @action async addCar(number, note) {
    const res = await userCarsAdd({ number, note }).noHandleError();
    if(res.ok) {
      this.items.unshift(res.data.car);
      return true;
    } else {
      if (res.error.is('car_belong_to_another_user')) {
        message.error('Данное авто уже имеется в базе и принадлежит пользователю с другим номером телефона. Если Вы уверены, что данное авто принадлежит именно Вам, позвоните ' + Env.phone, 7);
      } else {
        res.handleError();
      }

      return false;
    }
  }


  @action async remove(cids) {
    const hide = message.loading('Удаление..', 0);
    const data = await userCarsRemove(cids);
    const rows = this.items.slice(0).filter(i => cids.indexOf(i.cid) === -1);

    if(data) {
      this.items = rows;
    }

    hide();
    return data;
  }


  @action async check(row) {
    const res = await userCarsCheck(row.number);


    if(res) {
      if (!res.car)
        return true;
      const rows = this.items.slice(0);
      const index = rows.findIndex(r => r.id === res.car.id);
      rows[index] = res.car;

      this.items = rows;
      return true;
    }

    return false;
  }

  @action async export(numbers) {
    const res = await userCarsExport(numbers);
    if(res) {
      await save(res.data, 'cars.xlsx');
    } else {
      console.error('erro request', res);
    }
  }

  @action async reorder(page, from, to) {
    console.log('on reorder', page, from, to);

    const res = await userCarsReorder(from, to);
    if(res) {
      await this.loadAll(true);
      return true;
    }

    return false;
  }

  @action async orderUp(numbers) {
    const res = await userCarsOrderUp(numbers);
    if(res) {
      location.reload();
    }
  }

}



// WEBPACK FOOTER //
// ./src/stores/user-cars-store.js